export default __webpack_public_path__ + "static/media/academy-bg-bottom.c1d57aec.png";